module.exports = __webpack_public_path__ + "img/noData.f49bf434.png";